import { SlicesUIElement } from '../element/element';
import { BooleanConverter, NumberConverter } from 'html-element-property-mixins/src/utils/attribute-converters';

/**
 * 
 * @element object-position
 *  
 * @fires value-changed - Fires when 'value' changed
 * 
 * @prop {Boolean} [active=false] - If true, value can be changed using mouse
 * @attr {Boolean} active
 * 
 * @prop {Number} [zoom=1] - Zoom factor (no = 1)
 * @attr {Number} zoom
 * 
 * @prop {Number} [panX=50] - Pan on x-axis (0-100)
 * @attr {Number} pan-x
 * 
 * @prop {Number} [panY=50] - Pan on y-axis (0-100)
 * @attr {Number} pan-y
 * 
 * @prop {String} value = CSS keyframes string
 * @readonly
 * 
 */
class KenBurnsAnimation extends SlicesUIElement {
  static get properties() {
    return {

      active: {
        observe: true,
        DOM: true,
        fromAttributeConverter: BooleanConverter.fromAttribute
      },

      zoom: {
        observe: true,
        DOM: true,
        fromAttributeConverter: NumberConverter.fromAttribute
      },

      panX: {
        observe: true,
        DOM: true,
        fromAttributeConverter: NumberConverter.fromAttribute,
        attributeName: 'pan-x'
      },

      panY: {
        observe: true,
        DOM: true,
        fromAttributeConverter: NumberConverter.fromAttribute,
        attributeName: 'pan-y'
      },

    };
  }

  constructor() {
    super();
    this.active = false;
    this.zoom = 1;
    this.panX = 50;
    this.panY = 50;
  }

  propertiesChangedCallback(propNames, oldValues, newValues) {
    super.propertiesChangedCallback(propNames, oldValues, newValues);
    this.dispatchEvent(new CustomEvent('value-changed', {detail: this.value}));
  }

  get value() {
    if(!this.active || this.zoom === 1) return '';
    const coords = this._animationCoords;
    const name = ('kenburns' + Math.random()).replace(/\./g, '');

    const keyframes = `
      @keyframes ${name} {
        0% {
          opacity: 0;
          transform: translate(0%, 0%) scale3d(1, 1, 1);
        }
        5% {
          opacity: 1;
        }
        100% {
          opacity: 1;
          transform: translate(${coords.x}, ${coords.y}) scale3d(${this.zoom}, ${this.zoom}, ${this.zoom});
        }
      }
    `;
    
    return {
      keyframes: keyframes.replace(/\s+/g, ' '),
      name: name
    };
  }

  get _animationCoords() {
    const x = (typeof(this.panX) === 'number') ? this.panX : 50;
    const y = (typeof(this.panY) === 'number') ? this.panY : 50;
    const rangeSize = (this.zoom - 1) * 50 * 2;
    const maxRangeValue = rangeSize / 2;
    const xValue = Math.round(0 - (((x / 100) * rangeSize) - maxRangeValue));
    const yValue = Math.round(0 - (((y / 100) * rangeSize) - maxRangeValue));
    return {x: xValue + '%', y: yValue + '%'};
  }


}

window.customElements.define('kenburns-animation', KenBurnsAnimation);
